module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_7005.86c8b099.png";